// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import Select from '../controls/Select'
import type { LoadedAccount } from '../AgencyPage'
import type { ImportData } from './AccountsImport'
import type { OptionType } from '../types'

const ListItem: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  padding-bottom: 10px;
`
const AccountName: StyledComponent<Object, any, any> = styled.span`
  display: inline-block;
  width: 33%;
`
const SelectWrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  padding-left: 10px;
  width: 33%;
`

type Props = {|
  loadedAccount: LoadedAccount,
  accountOptions: Array<OptionType>,
  importData: Array<ImportData>,
  onChange: Function
|}

type State = {|
  selectedAccountId: number | null,
  importType: string | null
|}

const t = {
  ignore: 'Не добавлять',
  create_new: 'Создать новый кабинет',
  choose_existing: 'Выбрать существующий кабинет',
  choose_import_type: 'Выберите тип импортирования',
  choose_account: 'Выберите кабинет'
}

export default class AccountsImportListItem extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      selectedAccountId: null,
      importType: null
    }
  }

  render() {
    const { loadedAccount, onChange } = this.props
    const { selectedAccountId, importType } = this.state
    const listItemAccountOptions = this.listItemAccountOptions()
    return (
      <ListItem>
        <AccountName>{loadedAccount.name}</AccountName>
        <SelectWrapper>
          <Select
            value={importType || ''}
            placeholder={t.choose_import_type}
            options={this.accountImportOptions(listItemAccountOptions)}
            onChange={(importType) => {
              this.setState({ importType })
              if (!_.isEqual(importType, 'choose_existing')) {
                onChange({ importType })
              }
            }}
          />
        </SelectWrapper>
        {_.isEqual(this.state.importType, 'choose_existing') && (
          <SelectWrapper>
            <Select
              value={selectedAccountId || ''}
              placeholder={t.choose_account}
              options={listItemAccountOptions}
              onChange={(selectedAccountId) => {
                this.setState({ selectedAccountId })
                onChange({
                  importType: this.state.importType,
                  selectedAccountId: selectedAccountId
                })
              }}
            />
          </SelectWrapper>
        )}
      </ListItem>
    )
  }

  accountImportOptions(accountOptions: Array<OptionType>): Array<OptionType> {
    const defaultOptions = [
      { id: 'ignore', name: t.ignore },
      { id: 'create_new', name: t.create_new }
    ]
    return _.isEmpty(accountOptions)
      ? defaultOptions
      : _.concat(defaultOptions, { id: 'choose_existing', name: t.choose_existing })
  }

  listItemAccountOptions(): Array<OptionType> {
    const { accountOptions, importData } = this.props
    const selectedAccountIds = _.map(importData, (data) => {
      return data.selectedAccountId
    })
    return _.reject(accountOptions, (option) => {
      return _.includes(selectedAccountIds, option.id)
    })
  }
}
